import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from '@react-oauth/google';

import ProviderRoutes from "./Icommunetech/Providers/routes/provider.routes";
import ClientRoutes from "./Icommunetech/Clients/routes/client.routes";

import AllRoutes from "./Icommunetech/routes/all.routes";

import ScrollToTop from "./ScrollToTop";

const clientId = process.env.REACT_APP_AUTH_CLIENT_ID;

function App() {
  return (
    <>
    <GoogleOAuthProvider clientId={clientId}>
    <Router>
      <ScrollToTop />
      {/* <Providers />
      <Clients /> */}
      {/* <AllRoutes /> */}
      <Routes>
        <Route path="provider/*" element={<ProviderRoutes />} />
        <Route path="/*" element={<ClientRoutes />} />
      </Routes>

    </Router>
    </GoogleOAuthProvider>
    <ToastContainer />
    </>
  );
}

export default App;
